<template>
  <div class="blogBody">
    <div id="learn-header" v-if="!isMobile">
        <a id="logo" class="clickable flexwrap" href="https://www.learnandwatch.com"
             :style="{ backgroundImage: 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/logo2.webp)' }">
        </a>
    </div>
    <div class="blogList">
      <div v-if="!isMobile"><h1 id="blogTitle">Blog</h1></div>
      <div v-for="(content, num) in articlesList" :key="num" @click="$emit('selected', content.id)" class="mediumRoundAngles clickable blogPost flexwrap">
        <!--<div>aaa</div>-->
        <lazy-background class="poster centerBackground flexwrap"
                         :src="'https://learnandwatch.s3.eu-west-3.amazonaws.com/' + content.poster"
                         :placeholder='require("../assets/placeholder.png")' :blur="0" position="center">
        </lazy-background>
        <div class="blogPostContent">
          <div style="font-size: 1.1em">
            {{content.title}}
          </div>
          <div class="date">
            {{new Date(content.date_added).getDate()}} / {{new Date(content.date_added).getMonth()+1}} / {{new Date(content.date_added).getFullYear()}}
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "blogList",

  props: {
    articlesList: Array,
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>

  #learn-header {
    height: 3vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
    min-width: 23vw;
    max-width: 23vw;
    color: var(--navBackgroundColor);
  }

  #logo {
    margin-left: 1.2vw;
    height: 1.5vw;
    width: 6vw;
    align-content: center;

    background-size: contain;
    background-repeat: no-repeat;
  }

  #blogTitle{
    font-weight: bold;
    font-size: 2vw;
    margin: 0;
  }
  .blogBody{
    position: relative;

    max-height: calc(100% - 3vw);
    height: calc(100% - 3vw);
    min-height: calc(100% - 3vw);
    width: 23vw;
    min-width: 23vw;
    overflow: auto;
    background-color: var(--navBackgroundColor);
    padding: 3vw 0 0 0;
  }
  .blogList{

    display: grid;
    grid-gap: 1vw;

    font-weight: bold;
    max-height: calc(100% - 2vw);
    height: calc(100% - 2vw);
    min-height: calc(100% - 2vw);
    width: 21vw;
    min-width: 21vw;
    overflow: auto;
    justify-items: center;
    padding: 1vw;
  }

  .blogPost{
    height: 7vw;
    align-items: center;
    align-content: center;
    width: 19vw;
    overflow: hidden;
    display: grid;
    grid-template-columns: 5vw 1fr;
    background-color: #ffffff11;
  }
  .blogPostContent{
    max-height: calc(100% - 2vw);
    position: relative;
    padding: 1vw;
    display: grid;
    grid-template-rows: 1fr auto;
    grid-gap: 1vw;
  }
  .date{
    font-weight: normal;
    justify-self: flex-end;
  }
  .poster{
    height: 7vw;
  }

  @media screen and (max-device-width: 767px) {
    .blogBody{
      position: relative;

      max-height: 100vh;
      height: 100%;
      min-height: auto;
      width: auto;
      min-width: auto;
      overflow: auto;
      background-color: var(--navBackgroundColor);
      padding: 0px;
    }

    .blogList{
      display: grid;
      grid-gap: 1vw;
      font-weight: bold;
      max-height: max-content;
      height: max-content;
      min-height: auto;
      width: 80vw;
      min-width: 75vw;
      overflow: auto;
      justify-items: center;
      padding: 1vw;
    }

    .blogPost{
      height: max-content;
      align-items: center;
      align-content: center;
      width: 100%;
      overflow: auto;
      display: grid;
      grid-template-columns: 20vw 1fr;
      background-color: #ffffff11;
    }
    .blogPostContent{
      max-height: calc(100% - 2vw);
      position: relative;
      padding: 2vw;
      display: grid;
      grid-template-rows: 1fr auto;
      grid-gap: 1vw;
    }

    .poster{
      height: 28vw;
    }
  }

</style>